import React from 'react';
import { Trophy, DollarSign, Percent } from 'lucide-react';

const prizeDistribution = [
  { id: 'prize-1', rank: '1st Place', prize: '$2,500', percentage: '50%', tierClass: 'prize-tier-1', medal: '🥇' },
  { id: 'prize-2', rank: '2nd Place', prize: '$1,250', percentage: '25%', tierClass: 'prize-tier-2', medal: '🥈' },
  { id: 'prize-3', rank: '3rd Place', prize: '$750', percentage: '15%', tierClass: 'prize-tier-3', medal: '🥉' },
  { id: 'prize-4', rank: '4th–10th Place', prize: '$71 each', percentage: '10% split', tierClass: '', medal: '🎖️' },
];

export default function PrizeBreakdown() {
  return (
    <div className="rounded-xl p-5" style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
      <div className="flex items-center gap-2 mb-5">
        <Trophy size={18} style={{ color: '#F59E0B' }} />
        <h2 className="text-base font-bold text-foreground">Prize Breakdown</h2>
      </div>
      {/* Summary cards */}
      <div className="grid grid-cols-3 gap-3 mb-5">
        {[
          { label: 'Total Prize Pool', value: '$5,000', icon: Trophy, color: '#F59E0B' },
          { label: 'Platform Fee (10%)', value: '$500', icon: Percent, color: '#94A3B8' },
          { label: 'Entry Fee', value: '$10/player', icon: DollarSign, color: '#A78BFA' },
        ]?.map((item) => (
          <div key={`pb-${item?.label}`} className="p-3 rounded-xl text-center"
            style={{ background: `${item?.color}10`, border: `1px solid ${item?.color}25` }}>
            <item.icon size={16} style={{ color: item?.color, margin: '0 auto 6px' }} />
            <p className="text-sm font-extrabold mb-0.5" style={{ color: item?.color, fontVariantNumeric: 'tabular-nums' }}>{item?.value}</p>
            <p className="text-xs" style={{ color: 'var(--muted-foreground)', fontSize: '10px' }}>{item?.label}</p>
          </div>
        ))}
      </div>
      {/* Distribution table */}
      <div className="space-y-2">
        {prizeDistribution?.map((tier) => (
          <div key={tier?.id} className={`flex items-center justify-between p-3 rounded-xl ${tier?.tierClass}`}>
            <div className="flex items-center gap-3">
              <span className="text-lg">{tier?.medal}</span>
              <div>
                <p className="text-sm font-bold text-foreground">{tier?.rank}</p>
                <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>{tier?.percentage} of pool</p>
              </div>
            </div>
            <p className="text-base font-extrabold" style={{ color: 'var(--foreground)', fontVariantNumeric: 'tabular-nums' }}>
              {tier?.prize}
            </p>
          </div>
        ))}
      </div>
      <p className="text-xs mt-4 leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
        Prizes are distributed within 24 hours of result validation. Platform fee (10%) covers hosting, fair-play systems, and customer support. All amounts shown in USD. Currency conversion rates apply for non-USD wallets.
      </p>
    </div>
  );
}